import { Injectable, inject } from '@angular/core';
import { SecurityProfileQuery } from '../../loan-state';
import { SecurityProfileModel } from '../../loan-state/security-profile';
import { Cmg1003LookupsQuery } from '../../loan-state/lookups/lookups.query';
import { SecurityProfileRole } from '../../loan-state/security-profile/security-profile.model';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private readonly _securityProfileQuery = inject(SecurityProfileQuery);
  private readonly _lookupsQuery = inject(Cmg1003LookupsQuery);

  hasPermission(feature: string, permission: string): boolean {
    const profile = (this._securityProfileQuery.getActive() || {}) as SecurityProfileModel;
    return ((profile?.featurePermissions || {})[feature]?.permission || {})[permission] || false;
  }

  isAdmin(): boolean {
    const profile = (this._securityProfileQuery.getActive() || {}) as SecurityProfileModel;
    return profile?.isAdmin || false;
  }

  /** Return true for Production Assistant roles regardless of org producing status; otherwise use org flag. */
  canAssignLoansToOrg(): boolean {
    const profile = (this._securityProfileQuery.getActive() || {}) as SecurityProfileModel;
    const role = this._lookupsQuery.getSecurityProfileNameById(profile?.securityProfileId);
    const isProductionAssistant = role === SecurityProfileRole.ProductionAssistant || role === SecurityProfileRole.JVProductionAssistant;

    // OPTIONAL: also allow "All Branches" profiles
    const isAllBranches = (profile?.securityProfileName || '').toLowerCase().includes('all branches');

    if (isProductionAssistant || isAllBranches) {
      return true;
    }

    return profile?.canAssignLoansToOrg || false;
  }

  isBackgroundChecked(): boolean {
    const profile = (this._securityProfileQuery.getActive() || {}) as SecurityProfileModel;
    return profile?.isBackgroundChecked || false;
  }
}
